<template>
    <div class="container flex flex-direction">
        <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
        <div class="header-container flex align-center justify-between">
            <div class="flex align-center">
                <div class="btn-container" @click="$router.go(-1)">
                    <div class="btn"><i class="iconfont icon-fanhui margin-right-xs"></i>返回</div>
                </div>
                <div class="btn-container max margin-left-sm">
                    <div class="btn">{{ cur_time|date_time }}</div>
                </div>
            </div>
            <div class="page-title">双暖孝亲健康守护平台</div>
            <div class="flex align-center">
                <el-dropdown class="xiaoqu" trigger="click" @command="handleCommand">
                    <div class="btn-container mid right margin-left-sm">
                        <div class="btn">
                            {{ xiaoqu_name }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in xiaoqus" :key="index" :command="item">{{ item.name }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="map-container flex-sub flex">
            <dv-border-box-8 class="jc-total-container">
                <div class="classify-title">近一月</div>
                <div class="total-container number flex align-center padding-lr margin-top-sm">
                    <i class="icon iconfont icon-xindianjiance"></i>
                    <div class="label margin-left-sm flex-sub">监测次数</div>
                    <dv-digital-flop :config="{style:style,number:[push_num],content:'{nt}'}"
                                     class="number"/>
                </div>
                <div class="total-container number flex align-center padding-lr margin-top-xs">
                    <i class="icon iconfont icon-erji-anquanfuwukaitongqingkuang"></i>
                    <div class="label margin-left-sm flex-sub">异常次数</div>
                    <dv-digital-flop :config="{style:style,number:[save_order_num],content:'{nt}'}"
                                     class="number"/>
                </div>
                <div class="total-container number flex align-center padding-lr margin-top-xs">
                    <i class="icon iconfont icon-renqun"></i>
                    <div class="label margin-left-sm flex-sub">监控人数</div>
                    <dv-digital-flop :config="{style:style,number:[jumin_equipment_num],content:'{nt}'}"
                                     class="number"/>
                </div>

                <div class="flex justify-between margin-top-sm">
                    <div class="total-container baojing flex flex-direction align-center justify-center">
                        <div class="number-container flex align-center justify-center">
                            <i class="bg-icon iconfont icon-xieyang"></i>
                            <dv-digital-flop :config="{style:style,number:[xueyang_order_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                        <div class="label">血氧异常报警</div>
                    </div>
                    <div class="total-container baojing flex flex-direction align-center justify-center">
                        <div class="number-container flex align-center justify-center">
                            <i class="bg-icon iconfont icon-hamnatodynamometer"></i>
                            <dv-digital-flop :config="{style:style,number:[xueya_order_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                        <div class="label">血压异常报警</div>
                    </div>
                </div>
                <div class="flex justify-between margin-top-xs">
                    <div class="total-container baojing flex flex-direction align-center justify-center">
                        <div class="number-container flex align-center justify-center">
                            <i class="bg-icon iconfont icon-xinshuai"></i>
                            <dv-digital-flop :config="{style:style,number:[xinlv_order_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                        <div class="label">心率异常报警</div>
                    </div>
                    <div class="total-container baojing flex flex-direction align-center justify-center">
                        <div class="number-container flex align-center justify-center">
                            <i class="bg-icon iconfont icon-mianxingwendujitubiao"></i>
                            <dv-digital-flop :config="{style:style,number:[tiwen_order_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                        <div class="label">体温异常报警</div>
                    </div>
                </div>
                <div class="total-container online flex align-center margin-top-sm">
                    <div class="flex flex-direction">
                        <div class="classify-container flex align-center">
                            <i class="icon iconfont icon-xinhao"></i>
                            <div class="label">在线设备</div>
                            <dv-digital-flop :config="{style:min_style,number:[zaixian_equipment_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                        <div class="classify-container flex align-center margin-top-xs">
                            <i class="icon iconfont icon-yuyinguanbi"></i>
                            <div class="label">离线设备</div>
                            <dv-digital-flop :config="{style:min_style,number:[lixian_equipment_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                    </div>
                    <div class="flex flex-direction align-center margin-left-sm">
                        <div class="label margin-bottom-xs">监控范围内设备</div>
                        <div class="progress-container">
                            <el-progress type="circle" stroke-linecap="butt" color="#19caff" :show-text="false" :stroke-width="22" :width="100" :percentage="fanwei_lv"></el-progress>
                            <dv-digital-flop :config="{style:min_style,number:[fanwei_lv],content:'{nt}%'}"
                                             class="number progress"/>
                        </div>
                    </div>
                </div>
            </dv-border-box-8>
            <dv-border-box-8 class="jc-total-container flex-sub margin-left-sm">
                <div class="search-container flex">
                    <el-input class="input" v-model="name" placeholder="请输入用户姓名"></el-input>
                    <el-input class="input" v-model="phone" placeholder="请输入联系号码"></el-input>
                    <el-input class="input" v-model="IMEI" placeholder="请输入设备ID"></el-input>
                    <div class="search" @click="search"><i class="icon iconfont icon-31sousuo"></i>搜索</div>
                </div>
                <div class="watcher-container flex flex-wrap">
                    <div class="watcher-item flex flex-direction" v-for="(item,index) in list" :key="index">
                        <div class="name-container flex flex-direction align-center justify-center" :class="`status${item.warning_status}`">
                            <div class="flex align-center">
                                <div class="name" v-if="item.show_name">{{ item.name }}</div>
                                <div class="name" @click="item.show_name = true" v-else>{{ item.name | formatName }}</div>
                                <div class="phone margin-left-xs" v-if="item.show_phone">{{ item.phone }}</div>
                                <div class="phone margin-left-xs" @click="item.show_phone = true" v-else>{{ item.phone | phone_format }}</div>
                            </div>
                            <div class="phone margin-top-xs">{{ item.xiaoqu_name }}
                                <span v-if="item.show_address">{{ item.building_name
                                    }}{{ item.element_name }}单元{{ item.room_name }}</span>
                                <span  @click="item.show_address = true" v-else>****</span>
                            </div>
                            <router-link class="more" :to="`/digitize/health_info?id=${item.jumin_id}`">查看详细<i class="el-icon-arrow-right"></i></router-link>
                        </div>
                        <div class="flex flex-direction padding-xs">
                            <div class="flex justify-around">
                                <xin-lv-chart class="echarts" :values="item.xinlv"></xin-lv-chart>
                                <xue-ya-chart class="echarts" :values="item.xueya"></xue-ya-chart>
                            </div>
                            <div class="flex justify-around margin-top-sm">
                                <xue-yang-chart class="echarts" :values="item.xueyang"></xue-yang-chart>
                                <ti-wen-chart class="echarts" :values="item.tiwen"></ti-wen-chart>
                            </div>
                        </div>
                    </div>
                </div>
                <el-pagination
                    v-if="list.length > 0"
                    class="page-all"
                    background
                    @current-change="getSaveListScreenShenQu"
                    :current-page.sync="page"
                    :page-size="limit"
                    layout="prev, pager, next"
                    :total="total"
                >
                </el-pagination>
            </dv-border-box-8>
        </div>

    </div>
</template>

<script>

import {formatName, formatPhone, zhDate} from "@/utils/utils";
import {dataScreenShenQu, getAllXiaoQu, getSaveListScreenShenQu} from "@/api/tongji";
import XinLvChart from "@/views/digitize/components/XinLvChart";
import XueYaChart from "@/views/digitize/components/XueYaChart";
import XueYangChart from "@/views/digitize/components/XueYangChart";
import TiWenChart from "@/views/digitize/components/TiWenChart";

export default {
    name: "monitoring",
    components: {TiWenChart, XueYangChart, XueYaChart, XinLvChart},
    data() {
        return {
            cur_time: new Date().getTime(),
            style: {
                width: '120px',
                fontSize: 26,
                fill: '#ffd200',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                FontStyle: 'italic'
            },
            min_style: {
                width: '120px',
                fontSize: 20,
                fill: '#ffd200',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                FontStyle: 'italic'
            },
            xiaoqu_id: 0,
            xiaoqu_name: '全部小区',
            xiaoqus: [],


            push_num: 0,
            jumin_equipment_num: 0,
            zaixian_equipment_num: 0,
            lixian_equipment_num: 0,
            save_order_num: 0,
            xinlv_order_num: 0,
            tiwen_order_num: 0,
            xueyang_order_num: 0,
            xueya_order_num: 0,
            fanwei_lv: 0,
            loading: false,

            name: '',
            phone: '',
            IMEI: '',
            list: [],
            page: 1,
            total: 0,
            limit: 6,
        }
    },
    created() {
        this.xiaoqu_id = this.$route.query.id || ''
        this.xiaoqu_name = this.$route.query.name || '全部小区'
        this.getCurrentTime()
        this.getAllXiaoQu()
    },
    mounted() {
        this.onload()
    },
    methods: {
        onload() {
            this.loading = true
            this.init()
            this.setTimeoutGetData()
        },
        async getAllXiaoQu() {
            let _data = await getAllXiaoQu()
            this.xiaoqus = [...[{id: 0, name: '全部小区'}], ..._data.data]
        },
        setTimeoutGetData() {
            setInterval(() => {
                this.init()
            }, 1000 * 60)
        },
        //  获取数据
        async init() {
            let _data = await dataScreenShenQu(this.xiaoqu_id, this.name, this.phone, this.IMEI)
            this.push_num = _data.data.push_num
            this.jumin_equipment_num = _data.data.jumin_equipment_num
            this.zaixian_equipment_num = _data.data.zaixian_equipment_num
            this.lixian_equipment_num = _data.data.lixian_equipment_num
            this.save_order_num = _data.data.save_order_num
            this.xinlv_order_num = _data.data.xinlv_order_num
            this.tiwen_order_num = _data.data.tiwen_order_num
            this.xueyang_order_num = _data.data.xueyang_order_num
            this.xueya_order_num = _data.data.xueya_order_num
            // this.fanwei_lv =  _data.data.zaixian_equipment_num ? _data.data.zaixian_equipment_num / _data.data.jumin_equipment_num : 0
            this.fanwei_lv = 100
            await this.getSaveListScreenShenQu()
            this.loading = false
        },
        randomsort() {
            return Math.random() > .5 ? -1 : 1; //通过随机产生0到1的数，然后判断是否大于0.5从而影响排序，产生随机性的效果。
        },
        async getSaveListScreenShenQu() {
            let _data = await getSaveListScreenShenQu(this.xiaoqu_id, this.name, this.phone, this.IMEI, this.page, this.limit)
            // _data.data.map(item => {
            //     let _xinlv = item.xinlv[item.xinlv.length - 1]
            //     _xinlv.heartbeat = Number(_xinlv.heartbeat) + this.randomsort()*6
            //     item.xinlv.push(_xinlv)
            //     let _xueya = item.xueya[item.xueya.length - 1]
            //     _xueya.Diastolic = Number(_xueya.Diastolic) + this.randomsort()*3
            //     _xueya.Shrink = Number(_xueya.Shrink) + this.randomsort()*3
            //     item.xueya.push(_xueya)
            //     let _tiwen = item.tiwen[item.tiwen.length - 1]
            //     _tiwen.bodyTemperature = Number(_tiwen.bodyTemperature) + this.randomsort()*0.5
            //     item.tiwen.push(_tiwen)
            // })
            _data.data.map(item=>{
                item.show_name = false
                item.show_phone = false
                item.show_address = false
            })
            this.list = _data.data
            this.total = _data.total_number
        },
        search() {
            this.page = 1
            this.getSaveListScreenShenQu()
        },
        handleCommand(item) {
            this.xiaoqu_id = item.id
            this.xiaoqu_name = item.name
            this.onload()
        },
        getCurrentTime() {
            setInterval(() => {
                this.cur_time = new Date().getTime()
            }, 1000)
        }
    },
    filters: {
        date_time(val) {
            return zhDate(val, 8)
        },
        service_type(val) {
            switch (Number(val)) {
                case 1 :
                    return '主动求救'
                case 2 :
                    return '心率异常'
                case 3 :
                    return '体温异常'
                case 4 :
                    return '血糖异常'
                case 5 :
                    return '血氧异常'
                case 6 :
                    return '血压异常'
            }
        },
        phone_format(val) {
            return formatPhone(val)
        },
        formatName(val) {
            return formatName(val)
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    //height: 100vh;
    width: 1920px;
    height: 1080px;
    overflow: hidden;

    .loading {
        color: #ffffff;
        position: fixed;
        background: #33333333;
        z-index: 10;
    }

    .header-container {
        background: url(../../../assets/img/data/bg_monitoring.png) no-repeat top;
        background-size: 100% 100%;
        height: 102px;
        position: relative;
        padding: 0 36px;

        .page-title {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 36px;
            font-weight: 600;
            color: #ffffff;
        }

        .btn-container {
            transform: skew(25deg);
            width: 152px;
            height: 48px;
            min-width: 137px;
            line-height: 48px;
            box-shadow: inset 0px 0px 8px 3px #0096ff;
            background-color: #173979;
            text-align: center;
            font-size: 18px;
            color: #19caff;
            font-weight: 500;
            cursor: pointer;

            &.right {
                transform: skew(-25deg);

                .btn {
                    transform: skew(25deg);
                }
            }

            span {
                color: #fff;
            }

            .btn {
                transform: skew(-25deg);
            }

            &.max {
                width: 282px;
            }

            &.mid {
                width: 182px;
            }
        }


    }

    /deep/ {
        .el-pagination.is-background .el-pager li:not(.disabled).active {
            box-shadow: inset 0px 0px 8px 3px #0096ff;
            background: transparent;
        }
    }

    .map-container {
        width: 100%;
        height: calc(100vh - 102px);
        padding: 20px;

        .search-container {
            /deep/ {
                .input {
                    width: fit-content;
                    margin-right: 10px;

                    .el-input__inner {
                        width: 174px;
                        height: 47px;
                        background-color: #00226266;
                        border: solid 1px #19caff;
                        color: #FFFFFF;
                    }
                }
            }

            .search {
                width: 93px;
                height: 47px;
                line-height: 47px;
                text-align: center;
                background-color: #19caff;
                border: solid 1px #19caff;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;
            }
        }

        .watcher-container {
            .watcher-item {
                width: 460px;
                border: solid 1px #2593c9;
                margin-top: 20px;

                &:not(:nth-child(3n+1)) {
                    margin-left: 10px;
                }

                .name-container {
                    height: 80px;
                    background-color: #4db56c;
                    border-bottom: solid 1px #2593c9;
                    position: relative;
                    .more {
                        position: absolute;
                        color: #FFFFFF;
                        right: 12px;
                        bottom: 12px;
                        font-size: 12px;
                    }

                    &.status2 {
                        background-color: #d00505;
                    }

                    &.status1 {
                        background-color: #ffaa23;
                    }

                    .name {
                        font-size: 18px;
                        font-weight: 600;
                        color: #ffffff;
                    }

                    .phone {
                        font-size: 14px;
                        color: #ffffff;
                    }
                }

                .echarts {
                    width: 210px;
                    height: 125px;
                }
            }
        }

        .jc-total-container {
            width: 405px;
            height: unset;
            background-image: linear-gradient(0deg,
                #0c5da399 0%,
                #00226299 100%),
            linear-gradient(
                    #00226299,
                    #00226299);
            background-blend-mode: normal,
            normal;
            padding: 24px;

            .classify-title {
                font-size: 18px;
                font-weight: 600;
                color: #19caff;
            }

            .total-container {
                background-color: #00226266;
                border-radius: 10px;
                border: 1px solid #19caff;

                &.number {
                    height: 83px;

                    .icon {
                        width: 28px;
                        height: 28px;
                        line-height: 28px;
                        text-align: center;
                        border-radius: 28px;
                        background-color: #062b66;
                        font-size: 15px;
                        color: #34d0ff;
                    }
                }

                &.baojing {
                    width: 170px;
                    height: 170px;
                    padding: 0 16px;

                    .number-container {
                        background: linear-gradient(90deg, #ffffff01 0%, #ffffff01 10%, #062b66 50%, #ffffff01 90%, #ffffff01 100%);
                        background-blend-mode: normal, normal;
                        position: relative;
                        height: 69px;

                        .bg-icon {
                            font-size: 44px;
                            color: #34d0ff;
                            opacity: 0.2;
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                        }

                        &::after {
                            width: 100%;
                            height: 1px;
                            background: linear-gradient(70deg, #19caff33 0%, #1b85bf 30%, #19caff 50%, #1b85bf 80%, #19caff33 100%);
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;
                            right: 0;
                        }

                        &::before {
                            width: 100%;
                            height: 1.5px;
                            background: linear-gradient(70deg, #19caff33 0%, #1b85bf 30%, #19caff 50%, #1b85bf 80%, #19caff33 100%);
                            position: absolute;
                            content: '';
                            bottom: 0;
                            left: 0;
                            right: 0;
                        }
                    }

                    .label {
                        margin-top: 12px;
                    }
                }

                &.online {
                    height: 170px;
                    padding: 0 16px;

                    .classify-container {
                        width: 164px;
                        height: 62px;
                        border-radius: 10px;
                        box-shadow: inset 0px 0px 8px 3px #0096ff;

                        .icon {
                            font-size: 15px;
                            color: #34d0ff;
                            margin: 0 12px;
                        }

                        .number {
                            width: 60px;
                            height: 36px;
                        }

                        .label {
                            font-size: 16px;
                        }
                    }

                    .progress-container {
                        width: 100px;
                        height: 100px;
                        position: relative;

                        .progress {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }


                .label {
                    font-size: 18px;
                    color: #ffffff;
                }

                .number {
                    width: 120px;
                    height: 36px;
                }
            }
        }

    }
}
</style>
